<template>
  <div class="warp">
    <div class="head">
      <time-search
        ref="timeSearch"
        :control="{ data: timeData }"
        @timeControlChange="timeControlChange"
        @timeControlClick="TimeControlClick"
      >
      </time-search>
    </div>
    <div class="content">
      <div class="left">
        <div class="left-title">
          <div class="flex-1">组合列表</div>
          <el-button
            size="mini"
            icon="el-icon-plus"
            circle
            @click="addLine"
          ></el-button>
        </div>
        <div class="left-list">
          <div
            class="left-list-item"
            v-for="(line, key) in lineData"
            :key="key"
          >
            <div class="left-list-item-title">
              <div class="flex-1">{{ line.name }}</div>
              <div class="btn-icon">
                <i class="el-icon-edit" @click="editLineItem(line, key)"></i>
              </div>
              <div class="btn-icon" @click="delLineItem(key)">
                <i class="el-icon-delete"></i>
              </div>
            </div>
            <div class="left-list-item-content" style="overflow: auto;">
              <template v-for="(temp, tIndex) in line.data">
                <el-tag
                  size="mini"
                  class="tag"
                  v-for="(obj, index) in temp.measures"
                  :key="index + '_' + tIndex"
                  closable
                  @close="delMeasure(key, tIndex, index)"
                  >{{ obj.measureName }}【{{
                    temp.dataItem.displayName
                  }}】</el-tag
                >
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div id="chart" style="width:100%;height:100%"></div>
      </div>
    </div>
    <selected-msg-box
      v-if="addVisible"
      @cancel="addVisible = false"
      @confirm="addConfirm"
      :isEdit="isEdit"
      :data="editData"
      :statistics="true"
    ></selected-msg-box>
  </div>
</template>

<script>
import Api from "@common/api/index.js";
import dateTool from "@/utils/dateTool";
import TimeSearch from "@/components/common/TimeSearch.vue";
import SelectedMsgBox from "../SelectedMsgBox";
import echarts from "echarts";
export default {
  components: { TimeSearch, SelectedMsgBox },
  data() {
    return {
      timeData: [
        {
          type: "day",
          label: "日",
        },
        {
          type: "month",
          label: "月",
        },
        {
          type: "year",
          label: "年",
        },
      ],
      addVisible: false,
      isEdit: false,
      editIndex: null,
      editData: [],
      lineData: [],

      myChart: null,
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [],
      };

      this.myChart = echarts.init(document.getElementById("chart"));
      this.myChart.setOption(option);
    },
    addLine() {
      this.editData = [];
      this.isEdit = false;
      this.addVisible = true;
    },
    addConfirm(data) {
      if (this.editIndex !== null) {
        this.lineData[this.editIndex].data = data;
        this.editIndex = null;
      } else {
        const item = {
          data: data,
          name: this.lineData.length + 1 + "#组合",
        };
        this.lineData.push(item);
      }
      this.addVisible = false;
    },
    editLineItem(item, index) {
      this.editIndex = index;
      this.editData = item.data;
      this.isEdit = true;
      this.addVisible = true;
    },
    delLineItem(index) {
      this.lineData.splice(index, 1);
    },
    delMeasure(lineIndex, lineDataIndex, lineMeasureIndex) {
      this.lineData[lineIndex].data[lineDataIndex].measures.splice(
        lineMeasureIndex,
        1
      );
    },

    timeControlChange() {},
    TimeControlClick(obj) {
      console.log(obj);
      console.log(this.lineData);
      this.getStatisticsData(obj, this.lineData);
    },

    getStatisticsData(timeObj, lineData) {
      if (!timeObj) {
        return;
      }
      const api = {
        day: "getQuantitySumHour",
        month: "getQuantitySumDay",
        year: "getQuantitySumYear",
      };
      const { startTime, endTime } = timeObj;
      let apis = [];

      for (let i = 0; i < lineData.length; i++) {
        let measures = [];
        const line = lineData[i];
        for (let j = 0; j < line.data.length; j++) {
          const dataItem = line.data[j].dataItem;
          for (let k = 0; k < line.data[j].measures.length; k++) {
            const measure = line.data[j].measures[k];
            measures.push({
              measureId: measure.measureId,
              pointNumber: dataItem.pointNumber,
              pointCode: dataItem.pointCode,
            });
          }
        }
        apis.push(
          Api.quantity[api[timeObj.dateType]](
            measures,
            startTime,
            endTime,
            null
          )
        );
      }

      // 生成完整结构
      const obj = this.createXData(timeObj);

      Promise.all(apis).then((resArr) => {
        let series = [];
        for (let i = 0; i < resArr.length; i++) {
          const res = resArr[i];
          let serieItem = {
            name: lineData[i].name,
            type: "line",
            data: [],
          };
          for (let j = 0; j < obj.xData.length; j++) {
            const xDataItem = obj.xData[j];
            const resDataItem = res.data.find(
              (c) =>
                dateTool.format(new Date(c.time), obj.pattern) === xDataItem
            );
            if (resDataItem) {
              serieItem.data.push(resDataItem.value.toFixed(2));
            } else {
              serieItem.data.push("-");
            }
          }
          series.push(serieItem);
        }
        this.setChartOption(obj.xData, series);
      });
    },

    setChartOption(xData, series) {
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [],
      };
      if (this.myChart) {
        let legendData = [];
        for (let i = 0; i < series.length; i++) {
          legendData.push(series[i].name);
        }

        option.legend.data = legendData;
        option.xAxis.data = xData;
        option.series = series;

        this.myChart.setOption(option);
      }
    },
    createXData(timeObj) {
      let xData = [];
      let pattern = "";
      switch (timeObj.dateType) {
        case "day":
          for (let i = 0; i < 24; i++) {
            let label = i;
            if (i < 10) {
              label = "0" + label;
            }
            xData.push(label + "");
          }
          pattern = "hh";
          break;

        case "month":
          const startTime = new Date(timeObj.startTime);
          const days = new Date(
            startTime.getFullYear(),
            startTime.getMonth() + 1,
            0
          ).getDate();
          for (let i = 1; i <= days; i++) {
            let label = i;
            if (i < 10) {
              label = "0" + label;
            }
            xData.push(label + "");
          }
          pattern = "dd";
          break;

        case "year":
          for (let i = 1; i <= 12; i++) {
            let label = i;
            if (i < 10) {
              label = "0" + label;
            }
            xData.push(label + "");
          }
          pattern = "MM";
          break;

        default:
          break;
      }

      return { xData: xData, pattern: pattern };
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-icon {
  padding: 0px 4px;
  &:hover {
    cursor: pointer;
    color: #0080ff;
  }
}
.warp {
  width: calc(100% - 28px);
  margin: 0px auto;
  height: 100%;
  color: #000;
  display: flex;
  flex-flow: column;
  .head {
  }
  .content {
    flex: 1;
    display: flex;
    background: #fafafa;
    .left {
      flex: 0 0 300px;
      background: #fff;
      overflow: auto;
      display: flex;
      flex-flow: column;
      .left-title {
        flex: 0 0 36px;
        padding: 0px 10px;
        display: flex;
        text-align: left;
        align-items: center;
        border-bottom: 1px solid #dcdfe6;
      }
      .left-list {
        flex: 1;
        overflow: auto;
        .left-list-item {
          margin: 10px 10px;
          padding: 0px 10px;
          border: 1px dashed #dcdfe6;
        }
        .left-list-item-title {
          display: flex;
          align-items: center;
          text-align: left;
          height: 30px;
          line-height: 30px;
        }
        .left-list-item-content {
          min-height: 30px;
          text-align: left;
          padding-bottom: 6px;
        }
      }
    }
    .right {
      background: #fff;
      margin-left: 14px;
      flex: 1;
    }
  }
}
.flex-1 {
  flex: 1;
}
.tag {
  margin-top: 6px;
  margin-right: 6px;
}
.tag-btn {
  cursor: pointer;
  background: #fff;
  color: #666;
  &:hover {
    background: #ecf5ff;
    color: #409eff;
  }
}
</style>
